export const WINDOW_RESIZE_TRACKING_DEBOUNCE_MS: number = 320;

export enum PAGES_BASE_PATHNAMES {
  Home = '/',
  Login = '/login',
  SignUp = '/signup',
  Dashboard = '/access',
  Catalog = '/documentation',
}

export enum HashCodes {
  'DEFAULT' = '',
  'SIGN_IN' = 'sign-in',
}

export enum KeyCodes {
  'BACKSPACE' = 8,
  'ENTER' = 13,
  'LEFT_ARROW' = 37,
  'UP_ARROW' = 38,
  'RIGHT_ARROW' = 39,
  'DOWN_ARROW' = 40,
  'DELETE' = 46,
  'EQUAL_PLUS' = 187,
  'MINUS' = 189,
  'ESC_KEYCODE' = 27,
}

export enum KeyValues {
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  Escape = 'Escape',
}

export enum RegionCountries {
  'US' = 'United States',
}

export const EMAIL_REGEXP: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export enum MeasuringToolPopupCustomModes {
  Info = 'info',
  Error = 'error',
}

export enum TokenScopes {
  ImageGet = "image:get",
  DetectionFind ="detection:find",
  DetectionGet = "detection:get",
  FrameGet = "frame:get",
}